import { EventType } from '../types/enums/EventType'

export const BLOCKING_CONVERSATION_EVENT_TYPES: ReadonlySet<EventType> = new Set([
  EventType.AGENT_REPLY,
  EventType.TOOL_PERMISSION_REQUEST,
  EventType.PLAN_APPROVAL_REQUEST,
  EventType.AGENT_QUESTIONS,
])

export const BLOCKING_CONVERSATION_EVENT_TYPES_STRING: ReadonlySet<string> = new Set([
  'AGENT_REPLY',
  'TOOL_PERMISSION_REQUEST',
  'PLAN_APPROVAL_REQUEST',
  'AGENT_QUESTIONS',
])

export function isBlockingConversationEventType(eventType: EventType | string): boolean {
  if (typeof eventType === 'string') {
    return BLOCKING_CONVERSATION_EVENT_TYPES_STRING.has(eventType)
  }
  return BLOCKING_CONVERSATION_EVENT_TYPES.has(eventType)
}
